import { dateFormat } from "../../const/date";
import sanitizeHtml from "sanitize-html";

type BlogData = {
  data: {
    category: Array<string>;
    title: Array<string>;
    link: Array<string>;
    description: Array<string>;
    pubDate: Array<string>;
  }[];
};

const Blog = ({ data }: { data: BlogData[] | any[] }) => {
  const blog = ParseData({ data });

  const getTranslated = (key: string) => {
    const text = key || ""; //data json에서 호출
    const sanitizedText = sanitizeHtml(text, {
      allowedTags: ["br", "em", "span"], //허용할 태그 지정
    });
    return { __html: sanitizedText };
  };
  return (
    <div
      id="blog"
      className="relative w-full h-full py-14 lg:py-28 xl:pb-36 bg-primary"
    >
      <div className="relative w-full h-full px-[calc((100%-var(--container))/2)] mx-auto ">
        <div
          id="title"
          className="relative w-full h-fit text-left mb-10 xl:mb-14 text-white"
        >
          <div>
            <img
              alt="카이노스 바이오케미칼 로고"
              className="!relative w-auto h-full max-w-md max-h-10 lg:max-h-12 xl:max-h-[54px] py-1 object-contain cursor-pointer"
              src="/images/whiteLogo.webp"
              width={285}
              height={67}
            />
          </div>
          <p className=" lg:text-lg mt-5">
            확실한 <span className="text-point">전 · 후 비교!</span> 보다 자세한
            현장 이야기를 BLOG 에서 직접 확인해보세요!
          </p>
        </div>
        <div className="relative w-full h-full flex flex-wrap-reverse justify-between xl:grid grid-cols-3 gap-5">
          <div className="relative w-full h-full p-3 cursor-pointer">
            <img
              onClick={() => window.open("https://blog.naver.com/kainos_hanam")}
              src="/images/blogIcon.webp"
              alt="카이노스 바이오케미칼 네이버 블로그 바로가기"
              className="!relative w-full h-full object-contain max-w-60 mx-auto lg:max-w-none lg:mx-0"
            />
          </div>
          <div className="xl:col-span-2 relative w-full h-fit mx-auto grid grid-cols-2 gap-3 lg:gap-5">
            {blog.map((v, i) => (
              <div
                key={i}
                onClick={() => window.open(v.link[0])}
                className="relative w-full h-full"
              >
                <div className="relative w-full h-full grid bg-white p-2 md:p-3 rounded-3xl text-left border cursor-pointer transition-all duration-300 overflow-hidden">
                  <p
                    className={`relative w-full whitespace-nowrap overflow-hidden overflow-ellipsis lg:text-lg h-fit mb-1 lg:mb-2`}
                  >
                    {v.title[0]}
                  </p>
                  <small
                    className={`relative w-full whitespace-nowrap md:whitespace-normal overflow-hidden overflow-ellipsis h-fit md:h-9 my-2 lg:my-0 break-words md:line-clamp-2 text-sm opacity-60`}
                    dangerouslySetInnerHTML={getTranslated(v.description[0])}
                    // dangerouslySetInnerHTML={{ __html: v.description[0] }}
                  ></small>
                  <div className="md:pt-2 lg:mt-3 3xl:mt-4 lg:flex justify-between items-end">
                    <small className="hidden xl:block opacity-40 lg:text-sm">
                      {dateFormat(v.pubDate[0])}
                    </small>
                    <small className="text-main lg:text-sm">
                      {v.category[0]}
                    </small>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;

const parseString = require("xml2js").parseString;

const ParseData = ({ data }: { data: any[] }) => {
  const dataArr: {
    title: any;
    link: any;
    description: any;
    pubDate: any;
    category: any;
  }[] = [];

  parseString(data, (err: any, result: any) => {
    if (err) {
      console.error("XML 파싱 에러:", err);
      return;
    }

    const items = result?.rss?.channel?.[0]?.item;
    if (Array.isArray(items)) {
      items.slice(0, 8).forEach((v: any) => {
        dataArr.push({
          title: v.title,
          link: v.link,
          description: v.description,
          pubDate: v.pubDate,
          category: v.category,
        });
      });
    } else {
      console.warn("item 배열이 없습니다.");
    }
  });

  return dataArr;
};
